import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1038bcc3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card border-0 rounded-2 shadow-sm bg-white mb-4" }
const _hoisted_2 = { class: "card-header bg-light py-3 px-4 border-0 d-flex justify-content-between align-items-center" }
const _hoisted_3 = { class: "fw-bold text-primary mb-0" }
const _hoisted_4 = { class: "badge bg-success-subtle text-success fw-semibold fs-13 px-3 py-2" }
const _hoisted_5 = { class: "card-body p-4" }
const _hoisted_6 = { class: "row gy-4" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-primary mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-folder fs-18 me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Identificación ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Datos con los que el personal buscará la carpeta.")
], -1))
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Folio *", -1))
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Código / QR / Barra", -1))
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Año académico", -1))
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Curso", -1))
const _hoisted_16 = { class: "col-md-6" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Grupo", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-primary mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-map fs-18 me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Ubicación física ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Dónde está guardada la carpeta dentro de la institución.")
], -1))
const _hoisted_19 = { class: "col-md-4" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Sede *", -1))
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Área *", -1))
const _hoisted_23 = { class: "col-md-4" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Bloque / Edificio", -1))
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Piso", -1))
const _hoisted_27 = { class: "col-md-8" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Oficina / Cuarto", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-primary mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-archive fs-18 me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Coordenadas de almacenamiento ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Claves para ubicar la carpeta (armario/estante/posición).")
], -1))
const _hoisted_30 = { class: "col-md-4" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Tipo", -1))
const _hoisted_32 = { class: "col-md-4" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Código", -1))
const _hoisted_34 = { class: "col-md-4" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Repisa", -1))
const _hoisted_36 = { class: "col-md-3" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Fila", -1))
const _hoisted_38 = { class: "col-md-3" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Columna", -1))
const _hoisted_40 = { class: "col-md-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Posición", -1))
const _hoisted_42 = { class: "col-md-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Lado", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 mt-3" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-primary mb-2 d-flex align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "flaticon-lock fs-18 me-2 text-success" }),
    /*#__PURE__*/_createTextVNode(" Control ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-muted" }, "Estado de la carpeta y notas internas.")
], -1))
const _hoisted_45 = { class: "col-md-4" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary d-block" }, "Activo", -1))
const _hoisted_47 = { class: "col-md-4" }
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary d-block" }, "Confidencial", -1))
const _hoisted_49 = { class: "col-md-4" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Retención hasta", -1))
const _hoisted_51 = { class: "col-md-12" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-medium text-secondary" }, "Notas", -1))
const _hoisted_53 = { class: "col-md-12 mt-4" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h6", { class: "fw-bold text-primary mb-3 d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-info fs-18 me-2 text-success" }),
  /*#__PURE__*/_createTextVNode(" Resumen de ubicación ")
], -1))
const _hoisted_55 = {
  key: 0,
  class: "row g-3"
}
const _hoisted_56 = { class: "variable-card p-3 bg-white border border-success-subtle rounded shadow-sm d-flex align-items-center" }
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-code fs-16 text-success me-2" }, null, -1))
const _hoisted_58 = { class: "fw-semibold text-dark" }
const _hoisted_59 = {
  key: 1,
  class: "alert alert-secondary rounded mt-3 p-3 text-center fw-medium"
}
const _hoisted_60 = { class: "col-md-12 mt-4 d-flex justify-content-between align-items-center" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-save me-2" }, null, -1))
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "flaticon-close me-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_b_form_input = _resolveComponent("b-form-input")!
  const _component_SearchSelect = _resolveComponent("SearchSelect")!
  const _component_b_form_checkbox = _resolveComponent("b-form-checkbox")!
  const _component_b_form_textarea = _resolveComponent("b-form-textarea")!
  const _component_b_button = _resolveComponent("b-button")!
  const _component_b_container = _resolveComponent("b-container")!
  const _component_b_form = _resolveComponent("b-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.form.record.Id ? "Editar carpeta física" : "Nueva carpeta física"), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.form.record.Folio ? `Folio ${_ctx.form.record.Folio}` : "Sin folio"), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_b_form, {
        ref: "formRecord",
        id: "formEnrollmentPhysicalFolder",
        onSubmit: _withModifiers(_ctx.handleSubmit, ["prevent"])
      }, {
        default: _withCtx(() => [
          _createVNode(_component_b_container, { fluid: "" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Folio,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.record.Folio) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: FOL-2026-000123",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.FolderCode,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.record.FolderCode) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: QR-ABC-001"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.form.record.AcademicYear,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.record.AcademicYear) = $event)),
                    required: "",
                    options: _ctx.academicYears.map(r => ({ value: r.Id, text: `Año ${r.Year} - Período: ${r.StartDate.substring(0, 10)} Hasta ${r.EndDate.substring(0, 10)}` })),
                    placeholder: "Seleccione el año académico"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.form.record.GradeId,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.record.GradeId) = $event)),
                    required: "",
                    options: _ctx.courses.map(r => ({ value: r.Id, text: r.Name })),
                    placeholder: "Seleccione el curso"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _hoisted_17,
                  _createVNode(_component_SearchSelect, {
                    modelValue: _ctx.form.record.GroupId,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.record.GroupId) = $event)),
                    required: "",
                    options: _ctx.coursesGroup.filter(g => g.CourseId === _ctx.form.record.GradeId).map(r => ({ value: r.Id, text: r.Name })),
                    placeholder: "Seleccione el grupo"
                  }, null, 8, ["modelValue", "options"])
                ]),
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.SiteName,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.record.SiteName) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Sede Principal",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.AreaName,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.form.record.AreaName) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Secretaría / Archivo",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.BuildingName,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.form.record.BuildingName) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Bloque A"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.FloorName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.form.record.FloorName) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: 1 / 2 / PB"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _hoisted_28,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RoomName,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.form.record.RoomName) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Oficina 3 / Bodega"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, [
                  _hoisted_31,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.StorageType,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.form.record.StorageType) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: ARMARIO / ESTANTE / RACK"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.StorageCode,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.form.record.StorageCode) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: CAB-02 / EST-01 / CAJA-15"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Shelf,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.form.record.Shelf) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Repisa 3"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_36, [
                  _hoisted_37,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RowLabel,
                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.form.record.RowLabel) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Fila B"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.ColumnLabel,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.form.record.ColumnLabel) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: Col 4"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_40, [
                  _hoisted_41,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.PositionLabel,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.form.record.PositionLabel) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: A-12 / Pos 07"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_42, [
                  _hoisted_43,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.Side,
                    "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.form.record.Side) = $event)),
                    type: "text",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    placeholder: "Ej: IZQ / DER"
                  }, null, 8, ["modelValue"])
                ]),
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, [
                  _hoisted_46,
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.form.record.Enable,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.form.record.Enable) = $event)),
                    name: "checkbox-enable",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.record.Enable ? "Sí" : "No"), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_47, [
                  _hoisted_48,
                  _createVNode(_component_b_form_checkbox, {
                    modelValue: _ctx.form.record.IsConfidential,
                    "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.form.record.IsConfidential) = $event)),
                    name: "checkbox-confidential",
                    class: "mt-1"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.form.record.IsConfidential ? "Sí" : "No"), 1)
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_49, [
                  _hoisted_50,
                  _createVNode(_component_b_form_input, {
                    modelValue: _ctx.form.record.RetentionUntil,
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.record.RetentionUntil) = $event)),
                    type: "date",
                    class: "form-control rounded-1 shadow-none border-secondary-subtle"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_51, [
                  _hoisted_52,
                  _createVNode(_component_b_form_textarea, {
                    modelValue: _ctx.form.record.Notes,
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.record.Notes) = $event)),
                    class: "form-control rounded-1 shadow-none border-secondary-subtle",
                    rows: "3",
                    placeholder: "Observaciones internas..."
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  (_ctx.locationTokens.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locationTokens, (token, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "col-md-4 col-lg-3",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_56, [
                              _hoisted_57,
                              _createElementVNode("span", _hoisted_58, _toDisplayString(token), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_59, " Completa la ubicación/almacenamiento para ver el resumen. "))
                ]),
                _createElementVNode("div", _hoisted_60, [
                  _createVNode(_component_b_button, {
                    class: "default-btn border-0 fw-semibold text-white px-4 py-2 bg-success",
                    type: "submit",
                    loading: _ctx.form.loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_61,
                      _createTextVNode(" " + _toDisplayString(_ctx.form.record.Id ? "Guardar" : "Crear folio"), 1)
                    ]),
                    _: 1
                  }, 8, ["loading"]),
                  _createVNode(_component_b_button, {
                    onClick: _ctx.cancel,
                    class: "bg-transparent border-0 text-danger fw-semibold"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_62,
                      _createTextVNode(" Cancelar ")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["onSubmit"])
    ])
  ]))
}